module.exports = __webpack_public_path__ + "static/media/img_page09_a.af805e95.png";